import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import SettingRemoveModal from './SettingRemoveModal'

interface IRemoveMakeModalProps extends RouteComponentProps {
  setting: { label: string; id: string }
  id: string
  removeVehicleMake: (id: string) => Promise<any>
}

export default class RemoveMakeModal extends React.Component<IRemoveMakeModalProps> {
  public render() {
    return (
      <SettingRemoveModal
        setting={this.props.setting ? this.props.setting : { label: '', id: '' }}
        settingType='Make'
        onRemove={this.onRemove}
        onClose={this.onClose}
      />
    )
  }

  private onRemove = () => {
    this.props.removeVehicleMake(this.props.id).then(() => {
      setTimeout(() => {
        this.onClose()
      }, 1000)
    })
  }

  private onClose = () => {
    this.props.history.push('/global-settings/make')
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/RemoveMakeModal.tsx